<template>
  <v-card>
    <v-card-title>
      <router-link :to="{ name: 'ao_form', params: { user_id: userId } }">
        <v-btn fab class="mt-n4" :color="color" v-if="can_edit()">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </router-link>
      <p class="pl-5">
        <v-row
          ><v-img
            class="pl-5"
            src="/icons/amende.png"
            :aspect-ratio="1"
            width="40"
          />{{ $tc("ao.title", 2) }}</v-row
        >
      </p>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="aos"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="$store.state.ao.totalCount"
      dense
      show-expand
    >
      <template v-slot:expanded-item="{ headers }">
        <td class="pt-5" :colspan="headers.length"></td>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>

      <template #item.types="{ item }">
        {{ item.count_types }}
      </template>
      <template #item.done="{ item }">
        {{ item.count_done }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="pt-5 pb-5" :colspan="headers.length">
          <div v-for="(obj, index) in item.types" :key="index">
            <b>{{ obj.type.name }}</b
            >: {{ obj.count }}<br />
          </div>
        </td>
      </template>
      <template #item.date="{ item }">
        {{ item.date | date }}
      </template>
      <template #item.actions="{ item }">
        <EditDelete
          @delete="remove('ao', item)"
          :edit-path="{
            name: 'ao_form_edit',
            params: { ao_id: item.id, user_id: userId },
          }"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import EditDelete from "@/components/form/EditDelete"

const { mapActions } = createNamespacedHelpers("ao")

export default {
  name: "aosTable",
  components: { EditDelete },
  data: function () {
    return {
      options: {},
    }
  },
  mixins: [TableMixin],
  computed: {
    aos() {
      return this.$store.state.ao.data
    },

    headers() {
      let result = [
        {
          value: "date",
          text: this.$tc("common.date", 1),
          sortable: true,
          align: " text-no-wrap",
        },
        {
          value: "types",
          text: this.$tc("ao.count_type", 1),
          sortable: true,
          width: "45%",
        },
        {
          value: "done",
          text: this.$tc("ao.count_done", 1),
          sortable: false,
          width: "45%",
        },
      ]
      if(this.can_edit()) {
        result.push({
          value: "actions",
          align: "right",
        })
      }

      return result
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.user_id_local = this.$route.params.user_id
      this.getDataFromApi()
    },
  },
  methods: {
    ...mapActions([FETCH]),
    can_edit() {
      return  this.$store.state.user.item.can_edit
    },
  },
}
</script>
